module.exports = __webpack_public_path__ + "static/pid-ug-22-en-signrequest-2e58dd5b64e8dafccab1ba674c01e4d6.png";